import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import axios from "axios";
import config from "../../../config";
import { usePermissions } from "../../../permissions";
import { useSelector } from "react-redux";

const FarmFormModal = ({ visible, onClose, onSuccess, initialValues }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const account = useSelector((state) => state.account);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;
  const { createPermission } = usePermissions();

  useEffect(() => {
    if (visible && initialValues) {
      form.setFieldsValue(initialValues);
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, initialValues, form]);

  const handleSubmit = async () => {
    if (!createPermission) {
      message.warning("You don't have permission to add farms");
      return;
    }
    try {
      const values = await form.validateFields();
      setLoading(true);
      const payload = {
        ...values,
        userId: account.user.id,
        userName: account.user.firstname,
      };
      const response = await api.post(`/new-farm`, payload);
      if (response.data.message === "Farm already exists") {
        message.error(`Farm "${values.name}" already exists`);
      } else {
        message.success(`Farm "${values.name}" added successfully`);
        onSuccess();
        onClose();
      }
    } catch (error) {
      message.error(error.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={initialValues ? "Edit Farm" : "Add Farm"}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Submit
        </Button>,
      ]}
      width={500}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Farm Name"
          rules={[{ required: true, message: "Please enter farm name" }]}
        >
          <Input placeholder="Enter farm name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FarmFormModal;
